module.exports = __webpack_public_path__ + "static/media/closeGrey.783269cd.svg";